import { Injectable } from '@angular/core';
import { Emp } from 'app/common/models/emp.model';
import { HttpClient } from '@angular/common/http';
import {
    BehaviorSubject,
    Observable,
    switchMap,
    tap,
    take,
    map,
    filter,
} from 'rxjs';
import { environment } from 'environments/environment';
import { Pagination, PaginationApi } from '../../core/types/paginate.types';

@Injectable({
    providedIn: 'root',
})
export class EmpService {
    private _emps: BehaviorSubject<Emp[] | null> = new BehaviorSubject(null);
    private _emp: BehaviorSubject<Emp | null> = new BehaviorSubject(null);
    private _pagination: BehaviorSubject<Pagination | null> =
        new BehaviorSubject(null);

    constructor(private _httpClient: HttpClient) {}

    get pagination$(): Observable<Pagination> {
        return this._pagination.asObservable();
    }

    get emps$(): Observable<Emp[]> {
        return this._emps.asObservable();
    }

    get emp$(): Observable<Emp> {
        return this._emp.asObservable();
    }

    /**
     * Get docs
     *
     *
     * @param page
     * @param size
     * @param sort
     * @param order
     * @param search
     */
    /** Dominio de la empresa (EMP.KDOM → dom), sin tocar el estado compartido emp$. */
    domDeEmpresa(kemp: number): Observable<any> {
        return this._httpClient
            .get<Emp>(`${environment.urlApi}/api/emp/${kemp}`, {})
            .pipe(map((emp: any) => emp?.dom ?? null));
    }

    getById(id: number): Observable<Emp> {
        return this._httpClient
            .get<Emp>(`${environment.urlApi}/api/emp/${id}`, {})
            .pipe(
                tap((response) => {
                    console.log(response);
                    this._emp.next(response);
                })
            );
    }

    xsearchByDom(kdom: number, key: string): Observable<Emp> {
        return this._httpClient
            .get<Emp>(
                `${environment.urlApi}/api/emp/search-by-dom/${kdom}/${key}`,
                {}
            )
            .pipe(
                tap((response) => {
                    console.log(response);
                    this._emp.next(response);
                })
            );
    }

    searchByDom(
        page: number = 0,
        take: number = 100,
        orderby: string = 'name',
        order: 'ASC' | 'DESC' | '' = 'ASC',
        kdom: number,
        search: string
    ): Observable<{ meta: Pagination; data: Emp[] }> {
        const url = `${environment.urlApi}/api/emp/list/` + kdom;
        console.log('--> searchByDom()', url);
        console.log('page', page);
        console.log('take', take);
        console.log('kdom', kdom);
        return this._httpClient
            .get<{ meta: any; data: Emp[] }>(url, {
                params: {
                    page: '' + page,
                    take: '' + take,
                    orderby: orderby,
                    order: order,
                    search: search,
                },
            })
            .pipe(
                tap((response) => {
                    console.log('Get.Response', response);
                    console.log('Get.Response.meta', response.meta);
                    this._pagination.next({
                        length: response.meta.itemCount,
                        size: +response.meta.take,
                        page: +response.meta.page,
                        lastPage: response.meta.pageCount,
                        startIndex:
                            (+response.meta.page - 1) * +response.meta.take,
                        endIndex:
                            (+response.meta.page - 1) * +response.meta.take +
                            +response.meta.take,
                    });
                    this._emps.next(response.data);
                })
            );
    }

    create(emp): Observable<Emp> {
        return this.emps$.pipe(
            take(1),
            switchMap((emps) =>
                this._httpClient
                    .post<Emp>(`${environment.urlApi}/api/emp`, emp)
                    .pipe(
                        map((newEmp) => {
                            // Update the emps with the new emp

                            try {
                                // Intentar actualizar los emps con el nuevo emp
                                this._emps.next([newEmp, ...emps]);
                            } catch (error) {
                                console.error(
                                    'Error actualizando emps:',
                                    error
                                );
                            }
                            // Return the new emp
                            return newEmp;
                        })
                    )
            )
        );
    }

    update(id: number, emp: any): Observable<Emp> {
        delete emp.com;
        return this.emps$.pipe(
            take(1),
            switchMap((emps) =>
                this._httpClient
                    .patch<Emp>(`${environment.urlApi}/api/emp/` + id, emp)
                    .pipe(
                        map((updatedEmp) => {
                            console.log('updatedEmp A', updatedEmp);
                            try {
                            // Find the index of the updated emp
                            const index = emps.findIndex(
                                (item) => item.id === id
                            );
                            console.log('index', index);
                            // Update the emp
                            emps[index] = updatedEmp;

                            // Update the emps
                            this._emps.next(emps);
                            } catch (error) {
                                console.log('no pasa nada perrito')
                            }


                            // Return the updated emp
                            return updatedEmp;
                        }),
                        switchMap((updatedEmp) =>
                            this.emp$.pipe(
                                take(1),
                                filter((item) => item && item.id === id),
                                tap(() => {
                                    console.log('updatedEmp B', updatedEmp);
                                    // Update the emp if it's selected
                                    this._emp.next(updatedEmp);

                                    // Return the updated emp
                                    return updatedEmp;
                                })
                            )
                        )
                    )
            )
        );
    }

    delete(id: number): Observable<boolean> {
        console.log('--> deleteEmp()');
        console.log('id', id);
        return this.emps$.pipe(
            take(1),
            switchMap((emps) =>
                this._httpClient
                    .delete(`${environment.urlApi}/api/emp/` + id, {
                        params: { id },
                    })
                    .pipe(
                        map((isDeleted: boolean) => {
                            // Find the index of the deleted emp
                            const index = emps.findIndex(
                                (item) => item.id === id
                            );

                            // Delete the emp
                            emps.splice(index, 1);

                            // Update the emps
                            this._emps.next(emps);

                            // Return the deleted status
                            return isDeleted;
                        })
                    )
            )
        );
    }

    getToken(data: any): Observable<any> {
        return this._httpClient.post<any>(
            `${environment.urlApi}/api/col/get-token`,
            data
        );
    }

    sendColBank(data: any): Observable<any> {
        return this._httpClient.post<any>(
            `${environment.urlApi}/api/col/send-bank`,
            data
        );
    }

    getComi(data: any): Observable<any> {
        return this._httpClient.post<any>(
            `${environment.urlApi}/api/col/get-comi`,
            data
        );
    }

    sendDocument(data: any): Observable<any> {
        return this._httpClient.post<any>(
            `${environment.urlApi}/api/col/send-doc`,
            data
        );
    }

    getStatus(mode, kcol, toke): Observable<any> {
        console.log('---> getStatus()');
        console.log('mode', mode);
        console.log('kcol', kcol);
        console.log('toke', toke);
        return this._httpClient.get<any>(
            `${environment.urlApi}/api/col/get-status/${mode}/${kcol}/${toke}`,
        );
    }

    sendPay(mode, kcol, toke, fpay): Observable<any> {
        console.log('---> sendPay()');
        console.log('mode', mode);
        console.log('kcol', kcol);
        console.log('toke', toke);
        console.log('fpay', fpay);
        return this._httpClient.get<any>(
            `${environment.urlApi}/api/col/send-pay/${mode}/${kcol}/${toke}/${fpay}`,
        );
    }

    getCert(mode, toke, rutt): Observable<any> {
        console.log('---> sendPay()');
        console.log('mode', mode);
        console.log('toke', toke);
        console.log('rutt', rutt);
        return this._httpClient.get<any>(
            `${environment.urlApi}/api/col/get-cert/${mode}/${toke}/${rutt}`,
        );
    }
}
